import { render } from "./news-item.vue?vue&type=template&id=5fb32932&scoped=true"
import script from "./news-item.vue?vue&type=script&lang=js"
export * from "./news-item.vue?vue&type=script&lang=js"

import "./news-item.vue?vue&type=style&index=0&id=5fb32932&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb32932"]])

export default __exports__